module.exports = __webpack_public_path__ + "static/form-multiple-action-buttons-do-9e7993bda9fd26077082e20392bb47f3.png";